/**
 * Configuração central de idiomas.
 *
 * Para adicionar um idioma novo (ex.: francês):
 *   1. incluir a entrada em SUPPORTED_LANGUAGES;
 *   2. criar a pasta src/i18n/locales/fr-FR/ espelhando os arquivos de pt-BR;
 *   3. incluir o idioma em settings.LANGUAGES no backend.
 * Nada além disso — nenhum import ou mapa precisa ser editado.
 */

/** Tags BCP-47, o mesmo formato usado pelo navegador, pelo Intl e pela API. */
export const SUPPORTED_LANGUAGES = [
    { code: 'pt-BR', label: 'Português (Brasil)', shortLabel: 'PT' },
    { code: 'en-US', label: 'English (US)', shortLabel: 'EN' },
    // Espanhol neutro, sem região: 'es-MX', 'es-AR', 'es-ES' etc. caem aqui pelo idioma base.
    { code: 'es', label: 'Español', shortLabel: 'ES' },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);

/** Último recurso da cadeia de resolução de idioma. */
export const DEFAULT_LANGUAGE = 'pt-BR';

/**
 * Chave no localStorage. É a chave padrão do i18next-browser-languagedetector —
 * mantida para que o detector leia e escreva no mesmo lugar.
 */
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

export const DEFAULT_NAMESPACE = 'common';

/**
 * Resolve qualquer tag de idioma para um dos idiomas suportados.
 *
 * Faz o casamento por idioma base, então 'en-GB' e 'en' caem em 'en-US', e
 * 'pt-PT' cai em 'pt-BR'. Retorna null quando não há correspondência — quem
 * chama decide se usa o DEFAULT_LANGUAGE ou continua a cadeia de resolução.
 */
export function resolverIdiomaSuportado(tag) {
    if (!tag || typeof tag !== 'string') {
        return null;
    }

    const normalizada = tag.trim().toLowerCase();

    if (!normalizada) {
        return null;
    }

    const exata = SUPPORTED_LANGUAGE_CODES.find(
        (code) => code.toLowerCase() === normalizada
    );

    if (exata) {
        return exata;
    }

    const base = normalizada.split('-')[0];

    return SUPPORTED_LANGUAGE_CODES.find(
        (code) => code.toLowerCase().split('-')[0] === base
    ) || null;
}
